export default __webpack_public_path__ + "static/media/129.a09a47e1.jpg";